/**
 * Data model for the Edit Highlights modal (Recognition badges, Partner ID,
 * AWS metrics, Information badges).
 */

/** Single AWS metric row (label + description are fixed per type; value and visibility are editable). */
export type AwsMetricEntry = {
  id: string
  label: string
  description: string
  value: string
  isVisible: boolean
}

/** Single information badge row (fully editable). */
export type InformationBadgeEntry = {
  id: string
  label: string
  description: string
  value: string
  isVisible: boolean
}

/** Payload saved when the user clicks Update in the Edit Highlights modal. */
export type HighlightMetricsFormValues = {
  recognitionBadgeFileLinks: string[]
  partnerId: string
  awsMetrics: AwsMetricEntry[]
  informationBadges: InformationBadgeEntry[]
}

/** Fixed definitions for the 5 AWS metric sections (label + description). */
export const AWS_METRIC_DEFINITIONS: Omit<
  AwsMetricEntry,
  'value' | 'isVisible'
>[] = [
  {
    id: 'aws-competencies',
    label: 'AWS Competencies',
    description:
      'Shows the AWS Competencies earned by the partner, indicating validated expertise across specific workloads, industries, or solution areas.',
  },
  {
    id: 'service-validation',
    label: 'Service Validation',
    description:
      'Highlights AWS-validated services offered by the partner, demonstrating proven delivery capabilities and alignment with AWS best practices.',
  },
  {
    id: 'partner-program',
    label: 'Partner Program',
    description:
      'Displays the AWS Partner Program tier and program memberships associated with the partner, reflecting their level of engagement within the AWS Partner Network.',
  },
  {
    id: 'aws-certification',
    label: 'AWS Certification',
    description:
      "Represents AWS certifications held by the partner's team, showcasing technical knowledge and expertise across AWS services and architectures.",
  },
  {
    id: 'launches',
    label: 'Launches',
    description: 'Customer launches.',
  },
]
